<template>
  <div>
    <div :class="styles.FORM.FORM_GROUP">
      <label>
        Disable by role setting?
        <input type="checkbox" v-model="control.disableByRoleSetting">
      </label>
    </div>
    <div :class="styles.FORM.FORM_GROUP">
      <label>
        Has mask?
        <input type="checkbox" v-model="control.hasMask">
      </label>
      <div v-if="control.hasMask">
        <label>
          Mask format
          <p style="line-height: 0.8;">
            <code style="font-size: 8pt;">
              Usage example: ##.###-##
              <br/> #: Number (0-9)
              <br/> A: Letter in any case (a-z,A-Z)
              <br/> N: Number or letter (a-z,A-Z,0-9)
              <br/> X: Any symbol
            </code>
          </p>
        </label>
        <input type="text" :class="styles.FORM.FORM_CONTROL" v-model="control.mask">
      </div>
    </div>
    <div :class="styles.FORM.FORM_GROUP">
      <label>
        Has Default Value?
        <input type="checkbox" v-model="control.hasDefaultValue">
      </label>
      <div v-if="control.hasDefaultValue">
        <label>Role Reference</label>
        <v-select
            v-model="selectedItem"
            :items="items"
            item-text="alias"
            item-value="id"
            label="Select the Role Reference"
            single-line
            return-object
            :class="styles.FORM.FORM_CONTROL"
            @change="loadDataItems()"
        />
        <div>
          <label>Value Reference</label>
          <v-select
              v-if="itemsReference && itemsReference.length > 0"
              v-model="selectedItemReference"
              :items="itemsReference"
              item-text="name"
              item-value="name"
              label="Select the Role Reference"
              single-line
              return-object
              :hint="`${selectedItemReference ? selectedItemReference.value : ''}`"
              :class="styles.FORM.FORM_CONTROL"
              @change="loadDataItemsReference()"
          />
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {BaseControlConfigSkeleton} from 'v-form-builder';
import DefaultHelp from '@/components/tooltips/DefaultHelp';
import {dispatchGetRolesAdmin} from '@/store/admin/actions';
import {readAdminRoles} from '@/store/admin/getters';

export default {
  name: 'TextFieldConfigView',
  components: {DefaultHelp},
  extends: BaseControlConfigSkeleton,
  data: () => ({
    inputModel: null,
    selectedItem: null,
    items: [],
    selectedItemReference: null,
    itemsReference: [],
  }),
  async mounted() {
    await dispatchGetRolesAdmin(this.$store);
    this.items = readAdminRoles(this.$store);
  },
  methods: {
    loadDataItems() {
      if (this.selectedItem) {
        this.itemsReference = this.selectedItem.settings?.custom_data;
      }
    },
    loadDataItemsReference() {
      if (this.selectedItemReference) {
        this.control.defaultValueKey = this.selectedItemReference.name;
      }
    },
  },
};
</script>

<style scoped>

</style>
